import { render, staticRenderFns } from "./create-portfolio-section-constraint-configuration.vue?vue&type=template&id=69c8b8e5&scoped=true&lang=pug&"
import script from "./create-portfolio-section-constraint-configuration.vue?vue&type=script&lang=js&"
export * from "./create-portfolio-section-constraint-configuration.vue?vue&type=script&lang=js&"
import style0 from "./create-portfolio-section-constraint-configuration.vue?vue&type=style&index=0&id=69c8b8e5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8b8e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
